export default "__VITE_ASSET__cXnOtG6W__"